export const PENDING_IDEA_MATCHES_RECEIPT_KEY = 'xprojex_pending_idea_matches_receipt';

export const readPendingIdeaMatchesReceipt = (): string | null => {
  try {
    const receipt = window.localStorage.getItem(PENDING_IDEA_MATCHES_RECEIPT_KEY);
    return receipt && receipt.trim() ? receipt : null;
  } catch {
    return null;
  }
};

export const storePendingIdeaMatchesReceipt = (receipt: unknown): boolean => {
  if (typeof receipt !== 'string' || !receipt.trim()) return false;
  try {
    window.localStorage.setItem(PENDING_IDEA_MATCHES_RECEIPT_KEY, receipt);
    return true;
  } catch {
    return false;
  }
};

export const clearPendingIdeaMatchesReceipt = (): void => {
  try {
    window.localStorage.removeItem(PENDING_IDEA_MATCHES_RECEIPT_KEY);
  } catch {
    // An unavailable storage layer must not block the active Founder flow.
  }
};

export type IdeaMatchesContinuitySyncStatus = 'none' | 'retained' | 'discarded' | 'retry';

export const syncPendingIdeaMatchesReceipt = async (
  retain: (receipt: string) => Promise<{ ok: boolean; status: number }>,
): Promise<IdeaMatchesContinuitySyncStatus> => {
  const receipt = readPendingIdeaMatchesReceipt();
  if (!receipt) return 'none';

  try {
    const response = await retain(receipt);
    if (response.ok) {
      clearPendingIdeaMatchesReceipt();
      return 'retained';
    }
    if (response.status === 400) {
      clearPendingIdeaMatchesReceipt();
      return 'discarded';
    }
    return 'retry';
  } catch {
    return 'retry';
  }
};
